/* eslint-disable */
import React, { useEffect, useState, useMemo, lazy, Suspense } from 'react';
import { AiOutlineClose } from 'react-icons/ai';
import FilterIcon from '../../assets/icons/Filter.svg';
// import './App.css';
import { getAllEvent } from './checkOddHelper';
import LoadingSpinner from './components/LoadingSpinner';
const LeagueGroup = lazy(() => import('./components/LeagueGroup'));
import { FaFilter } from "react-icons/fa";
import { useWindowWidth } from '@react-hook/window-size';

const CheckOdd = React.memo(() => {
  const onlyWidth = useWindowWidth();
  const [events, setEvents] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [searchInput, setSearchInput] = useState('');
  const [isFilterOpen, setIsFilterOpen] = useState(false);
  const [selectedLeagues, setSelectedLeagues] = useState([]);
  const [allLeaguesSelected, setAllLeaguesSelected] = useState(true);
  const [viewType, setViewType] = useState("normal");
  const searchKeys = ["leagueName", "homeTeam", "homeTeamMyan", "awayTeam", "awayTeamMyan"]

  useEffect(() => {
    const info = JSON.parse(sessionStorage.getItem("companyList"));
    if(!info){
       window.location.href = "/login"
   }
    getEvent(info?.[0].baseURL);
  }, []);

  const filteredMatches = useMemo(() => {
    searchInput === '' && setAllLeaguesSelected(true)
    // Filter events based on the search input
    const filtered = events.filter((event) => {
      const searchTerm = searchInput.toLowerCase();
      return searchKeys.some(key => event[key].toLowerCase().includes(searchTerm))
    });

    // Group filtered matches by league name
    const grouped = filtered.reduce((groups, match) => {
      if (!groups[match.leagueName]) {
        groups[match.leagueName] = [];
      }
      groups[match.leagueName].push(match);
      return groups;
    }, {});
    return grouped;
  }, [events, searchInput]);

  const getEvent = async () => {
    try {
      setIsLoading(true);
      const res = await getAllEvent();
      //console.log("res>>>>>>>>>>>>>>>>>>>.",res.eventDetails);
      const temp = res.eventDetails;
      const sortedMatches = temp.sort((a, b) => {
        if (a.leagueName === b.leagueName) {
          return new Date(a.eventTime) - new Date(b.eventTime);
        }
        return a.leagueName.localeCompare(b.leagueName);
      });
      setEvents(sortedMatches);
    } catch (error) {
      console.log({ error });
    } finally {
      setIsLoading(false);
    }
  };

  const clearSearch = () => {
    setSearchInput('');
  };

  const handleLeagueCheckboxChange = (event) => {
    const leagueName = event.target.value;
    setSelectedLeagues((prevSelectedLeagues) =>
      event.target.checked
        ? [...prevSelectedLeagues, leagueName]
        : prevSelectedLeagues.filter((name) => name !== leagueName)
    );
  };

  useEffect(() => {
    setSelectedLeagues(allLeaguesSelected ? Object.keys(filteredMatches) : []);
  }, [allLeaguesSelected]);

  useEffect(() => {
    setSelectedLeagues(Object.keys(filteredMatches));
  }, [filteredMatches]);

  useEffect(() =>{
     onlyWidth < 640 ? setViewType("normal") : setViewType("smart");
  },[onlyWidth])

  return (
    <div className='w-full h-full flex flex-col relative overflow-y-scroll overflow-x-hidden'>
      {isLoading && <LoadingSpinner />}
      <div className='flex flex-col w-full justify-center items-center px-2'>
        {/* Search input */}
        <div className='flex w-full justify-between relative'>
          {/* <div className='my-3'>
            <span className='mx-3 font-bold text-slate-900'>Gambling Limit</span>
          </div> */}
          <div className='relative flex gap-4'>
            <div>
            <label className='text-slate-900 text-base font-semibold dark:text-customWhite'>Search : </label>
            <input
              type='text'
              placeholder='League, Team'
              value={searchInput}
              onChange={(e) => setSearchInput(e.target.value)}
              className='my-2 py-1 px-2 border rounded-md bg-primary text-white focus:border-blue-500'
            />
            {searchInput && (
              <button
                onClick={clearSearch}
                className='absolute right-2 top-1/2 transform -translate-y-1/2 text-white'
              >
                <AiOutlineClose size={18} />
              </button>

            )}
            </div>
             <button
            onClick={() => setIsFilterOpen(!isFilterOpen)}
            className='rounded px-2 text-sm text-gray-400 hover:text-gray-400 cursor-pointer flex items-center'
          >
            {/* <img className='mt-1 mr-1 w-7 h-7' src={FilterIcon} alt='ball' /> */}
            <FaFilter />
          </button>
          </div>
          {
            onlyWidth < 640 ? null :
          <div className='flex items-center gap-3'>
            <label className='text-slate-900 text-base font-semibold dark:text-customWhite'>
              <input
                type="radio"
                name="leagueFilter"
                value="normal"
                checked={viewType === "normal"}
                onChange={() => setViewType("normal")}
                className='mr-2'
              />
              Normal View
            </label>
             <label className='text-slate-900 text-base font-semibold dark:text-customWhite'>
              <input
                type="radio"
                name="leagueFilter"
                value="smart"
                checked={viewType === "smart"}
                onChange={() => setViewType("smart")}
                className='mr-2'
              />
              Smart View
            </label>
          </div>}
        </div>

        {isFilterOpen && (
          <div className='flex absolute justify-center items-center w-screen h-screen bg-primary/80 top-0 right-0'>
            <div className='w-full m-2 sm:w-[500px] backdrop-blur-sm border bg-secondary/20 rounded-md p-4 shadow-md'>
              <div className='flex justify-between'>
                <button
                  onClick={() => setAllLeaguesSelected(!allLeaguesSelected)}
                  className='mb-2 px-2 py-1 text-sm text-white rounded-md hover:bg-lightBlue cursor-pointer'
                >
                  {allLeaguesSelected ? 'Deselect All' : 'Select All'}
                </button>
                <button
                  onClick={() => setIsFilterOpen(false)}
                  className='transform -translate-y-1/2 text-white mt-1'
                >
                  <AiOutlineClose size={18} />
                </button>
              </div>
              <div className='h-[85vh] overflow-auto'>
                {Object.keys(filteredMatches).map((leagueName) => (
                  <label key={leagueName} className='flex items-center text-white font-medium text-md'>
                    <input
                      type='checkbox'
                      value={leagueName}
                      checked={selectedLeagues.includes(leagueName)}
                      onChange={handleLeagueCheckboxChange}
                      className='mr-2'
                    />
                    {leagueName}
                  </label>
                ))}
              </div>
            </div>
          </div>
        )}
        <div className={`${viewType === "normal" ? "flex-1 overflow-auto" : "w-full"}`}>
        {/* Render filtered and grouped events */}
        {Object.entries(filteredMatches).map(([leagueName, matches], index) => (
          selectedLeagues.includes(leagueName) && (
            <Suspense key={index + leagueName} fallback={<div className="border-t-4 border-l-2 border-white rounded-full animate-spin w-8 h-8" />}>
              <LeagueGroup key={index + leagueName} leagueName={leagueName} matches={matches} viewType={viewType}/>
            </Suspense>
          )
        ))}
        </div>
      </div>
    </div>
  );
});

export default CheckOdd;

